import { updateResponsibilities, withLoginUser } from 'src/api/user'
import { ResponsibilitiesForm } from './ResponsibilitiesForm'

export const ResponsibilitiesEditor = withLoginUser(({ user }) => (
  <ResponsibilitiesForm user={user} submit={updateResponsibilities} />
))
